import { render, staticRenderFns } from "./DeudaForm.vue?vue&type=template&id=2c32c8c6&scoped=true"
import script from "./DeudaForm.vue?vue&type=script&lang=js"
export * from "./DeudaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c32c8c6",
  null
  
)

export default component.exports